import { BlossomRoutes, StudioRoutes } from 'Routing/RouteConstants';

export const PAGE_NOT_FOUND_AUTHED_TEXT = {
  title: 'Sorry, the page cannot be reached.',
  description: 'The URL requested does not exist.',
  chooseOption: 'Choose from one of the following',
  contactAdmin: 'If you need further help please contact your system administrator.',
  cards: {
    studio: {
      label: 'Studio',
      info: 'Capture, map and publish business questions for better decision making.',
      permissionRef: StudioRoutes.permissions,
    },
    tower: {
      label: 'Tower',
      info: 'Your control tower for an intelligent 360 view of all your assets.',
      permissionRef: StudioRoutes.permissions,
    },
    cloudAdmin: {
      label: 'Cloud Admin',
      info: 'Setup your admins, tenants, and security.',
      permissionRef: BlossomRoutes.podManagement.permission,
    },
  },
};
